import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import { TOURS, formatBRL } from "@/lib/tours";
import { IMAGES } from "@/lib/images";
import Reveal from "@/components/landing/Reveal";

const MiniCard = ({ tour }) => (
  <Link
    to={`/${tour.slug}`}
    data-testid={`other-tour-${tour.slug}`}
    className="group flex flex-col overflow-hidden rounded-2xl border border-white/10 bg-[#161B22] transition-[border-color,transform] duration-500 hover:-translate-y-1.5 hover:border-amber-400/40"
  >
    <div className="relative aspect-[16/10] overflow-hidden">
      <img
        src={IMAGES[tour.image]}
        alt={tour.name}
        loading="lazy"
        className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#161B22] via-transparent to-transparent" />
      <span className="absolute left-4 top-4 flex items-center gap-1.5 rounded-full border border-white/20 bg-[#0D1117]/70 px-3 py-1 font-mono text-[10px] font-semibold uppercase tracking-[0.15em] text-amber-300 backdrop-blur-md">
        <Clock className="h-3 w-3" />
        {tour.duration}
      </span>
    </div>
    <div className="flex flex-1 flex-col p-5">
      <h3 className="font-display text-lg font-bold leading-snug text-stone-50">{tour.name}</h3>
      <p className="mt-2 text-sm text-stone-400">
        A partir de <span className="font-semibold text-amber-400">R$ {formatBRL(tour.price)}</span> por pessoa
      </p>
      <span className="mt-4 flex items-center gap-2 text-sm font-semibold text-stone-300 transition-colors duration-300 group-hover:text-amber-400">
        Ver passeio
        <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
      </span>
    </div>
  </Link>
);

export default function OtherTours({ current }) {
  const others = TOURS.filter((t) => t.slug !== current.slug);
  return (
    <section className="mx-auto max-w-7xl px-5 py-20 sm:px-8 sm:py-28">
      <Reveal className="flex flex-wrap items-end justify-between gap-6">
        <div>
          <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-amber-400">
            Outros passeios
          </p>
          <h2 className="mt-4 font-display text-3xl font-extrabold leading-tight tracking-tight text-stone-50 sm:text-4xl">
            Prefere{" "}
            <em className="font-accent font-medium italic text-amber-400">outro roteiro?</em>
          </h2>
        </div>
        <Link
          to="/#passeios"
          data-testid="other-tours-all-link"
          className="group flex items-center gap-2 text-sm font-semibold text-stone-300 transition-colors duration-300 hover:text-amber-400"
        >
          Ver catálogo completo
          <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
      </Reveal>
      <div data-testid="other-tours-grid" className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {others.map((tour, i) => (
          <Reveal key={tour.slug} delay={Math.min(i, 3) * 0.08}>
            <MiniCard tour={tour} />
          </Reveal>
        ))}
      </div>
    </section>
  );
}
